module.exports = __webpack_public_path__ + "static/img/sangwenfeng.1c6b8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/sangwenfeng.png
// module id = IUem
// module chunks = 0